import { ApiService, StaticFileContent } from '@ebeihilfe/core';
import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { CustomComponentModule } from '../../../components';
import { Observable } from 'rxjs';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { map } from 'rxjs/operators';

@Component({
  selector: 'portal-start-page',
  templateUrl: './start-page.component.html',
  styleUrls: ['./start-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CustomComponentModule, TranslateModule, AsyncPipe, ReactiveFormsModule],
})
export class StartPageComponent implements OnInit {
  private readonly api = inject(ApiService);
  public content$: Observable<StaticFileContent>;

  public ngOnInit(): void {
    this.content$ = this.api
      .getStaticInfoFile()
      .pipe(map((content: StaticFileContent) => (content.body ? content : null)));
  }
}
